












































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import Icon from '../common/Icon.vue';

export enum BenefitTextType {
  Highlight = 'highlight',
  Normal = 'normal',
}

export interface BenefitText {
  type: BenefitTextType;
  text: string;
}

export interface PremiumBenefit {
  isBenfit: boolean;
  texts: BenefitText[];
}

@Component({
  components: { Icon },
})
export default class PremiumBenefitItem extends Vue {
  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Prop({ required: true })
  benefits!: PremiumBenefit[];
}
